import { render, staticRenderFns } from "./UrunDuzenle.vue?vue&type=template&id=5e974dae&scoped=true&"
import script from "./UrunDuzenle.vue?vue&type=script&lang=js&"
export * from "./UrunDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./UrunDuzenle.vue?vue&type=style&index=0&id=5e974dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e974dae",
  null
  
)

export default component.exports